// extracted by mini-css-extract-plugin
export default {"container":"style_container__DK5uo","img":"style_img__TVGDu","title":"style_title__QDoil"};